export const environment = {
  production: false,
  apiUrl: 'https://const-credit-test.internal.sparbankensyd.se/api',
  authServiceUrl: 'https://const-credit-test.internal.sparbankensyd.se/service',
  domain: 'const-credit-test.internal.sparbankensyd.se'
}
